// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__riFtZ","content":"LoadingAlert_content__1g_to"};